














































































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {LongueursAchat} from '@/models';

import CrudLongueursAchatFilter from '@/components/Crud/LongueursAchat/Filter.vue';
import CrudLongueursAchatEditDialog from '@/components/Crud/LongueursAchat/EditDialog.vue';
import CrudLongueursAchatList from '@/components/Crud/LongueursAchat/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeLongueursAchat from '@/stores/modules/longueursAchat';

@Component({
	components: {
		CrudLongueursAchatFilter,
		CrudLongueursAchatEditDialog,
		CrudLongueursAchatList,
		CrudDeleteDialog,
	}
})
export default class LongueursAchatView extends Vue {
	
	@Stored(() => storeLongueursAchat)
	private LongueursAchats!: ResultType<LongueursAchat>;
	
	private editLongueursAchat: LongueursAchat = null;
	private deletedLongueursAchat: LongueursAchat = null;
	private storeLongueursAchat = storeLongueursAchat;
	
	@Emit()
	private onCreate(): void {
		this.editLongueursAchat = new LongueursAchat();
	}

	private refresh(): void {
		storeLongueursAchat.dispatch('getC', { filters: true });
	}
}
